import React from 'react';
import { observer } from 'mobx-react';
import { GridBackorderedCellTemplate } from 'themes/components';

@observer
class GridBackorderedCell extends React.Component {
    render() {
        return (
            <GridBackorderedCellTemplate {...this.props}/>
        );
    }
}

export default GridBackorderedCell;